import {
  GET_INTERNETS,
} from "../actions/types";
const initialState = {
  list: [],
  loading: true,
};

const internetReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_INTERNETS:
      return {
        ...state,
        list: action.payload,
        loading: false,
      };

    default:
      return state;
  }
}

export default internetReducer
